import React, { useState } from "react";
import { CaretLeft, Check } from "@phosphor-icons/react";
import { TTS_SPEED_OPTIONS, getTtsSpeed, setTtsSpeed } from "../../lib/ttsSpeed";

/**
 * Settings → "Voice speed" sub-page. Lets the user slow down or speed up
 * the translated TTS playback. Persists to localStorage; consumed by
 * playB64() in TranslatePanel via getTtsSpeed().
 */
export default function VoiceSpeedPicker({ onBack }) {
  const [value, setValue] = useState(getTtsSpeed());

  function choose(v) {
    setValue(v);
    setTtsSpeed(v);
  }

  return (
    <div className="min-h-screen bg-bone pb-24" data-testid="voice-speed-page">
      <div className="sticky top-0 z-10 bg-bone/95 backdrop-blur-sm border-b border-navy/10">
        <div className="max-w-md mx-auto px-4 py-3 flex items-center gap-3">
          <button
            onClick={onBack}
            data-testid="voice-speed-back-btn"
            className="w-9 h-9 rounded-full bg-white border border-navy/10 flex items-center justify-center"
          >
            <CaretLeft size={18} weight="bold" color="#0E2C54" />
          </button>
          <h1 className="font-jakarta font-extrabold text-navy text-xl">
            Voice speed
          </h1>
        </div>
      </div>

      <div className="max-w-md mx-auto px-4 pt-4 space-y-4">
        <p className="font-jakarta text-sm text-navy-soft leading-relaxed">
          Adjust how fast the translated voice speaks. Useful when you're
          learning the pronunciation or speaking quickly with someone.
        </p>

        <div className="bg-white rounded-2xl shadow-soft divide-y divide-navy/5">
          {TTS_SPEED_OPTIONS.map((opt) => {
            const selected = opt.value === value;
            return (
              <button
                key={opt.value}
                type="button"
                onClick={() => choose(opt.value)}
                data-testid={`voice-speed-option-${opt.value}`}
                className="w-full flex items-center justify-between px-4 py-3.5 active:bg-bone/60 transition-colors"
              >
                <div className="text-left">
                  <div className="font-jakarta font-extrabold text-navy text-base">
                    {opt.label}
                  </div>
                  <div className="font-jakarta text-navy-soft text-xs">
                    {opt.description}
                  </div>
                </div>
                {selected && (
                  <div
                    className="w-7 h-7 rounded-full bg-forest flex items-center justify-center"
                    aria-label="Selected"
                  >
                    <Check size={14} weight="bold" color="#fff" />
                  </div>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
